import * as yup from "yup";

const rawColumnSchema = yup.object().shape({
  type: yup.string().oneOf(["raw"]).required(),
  modelId: yup.string().required(),
  name: yup.string().required(),
});

const relatedColumnSchema = yup.object().shape({
  type: yup.string().oneOf(["related"]).required(),
  path: yup.array().of(yup.string().required()).defined(),
  column: rawColumnSchema,
});

const propertySchema = yup.lazy((value) => {
  if (
    value &&
    typeof value === "object" &&
    "type" in value &&
    value?.type === "related"
  ) {
    return relatedColumnSchema;
  }
  return rawColumnSchema;
});

const columnValueSchema = yup.object().shape({
  type: yup.string().oneOf(["column"]).required(),
  property: relatedColumnSchema,
  propertyType: yup.string(),
});

export const filterSchema = yup.object().shape({
  type: yup.string().required(),
  conditions: yup.array().of(
    yup.object().shape({
      type: yup.string().required(),
      property: propertySchema,
      value: yup.lazy((value) => {
        if (
          value &&
          typeof value === "object" &&
          "type" in value &&
          value.type === "column"
        ) {
          return columnValueSchema;
        }
        return yup.mixed().required();
      }),
      operator: yup.string().required(),
      propertyType: yup.string(),
    }),
  ),
});
